import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import { defineComponent as _defineComponent } from 'vue';
import { useListPromptTemplateVersionQuery, useUpsertPromptTemplateVersionMutation, useUpsertPromptTemplateMutation, useDeletePromptTemplateVersionMutation, TemplateEngineContext } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'PromptTemplateEdit',
  props: {
    id: {
      type: String,
      required: false
    },
    questionId: {
      type: Number,
      required: false
    },
    ixId: {
      type: String,
      required: false
    },
    promptTemplate: {
      type: Object,
      required: false
    },
    context: {
      type: String,
      required: false,
      default: function _default() {
        return TemplateEngineContext.Fund;
      }
    }
  },
  emits: ['prompt-template-created'],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var activeTab = ref(0);
    var promptTemplateExpanded = ref(false);

    // Track which version is being edited (null = none, versionId = editing that version)
    var editingVersionId = ref(null);

    // Track original values to prevent unnecessary updates
    var originalValues = ref({});
    var _useListPromptTemplat = useListPromptTemplateVersionQuery(computed(function () {
        var _props$promptTemplate;
        return {
          filters: {
            promptTemplateId: props === null || props === void 0 ? void 0 : (_props$promptTemplate = props.promptTemplate) === null || _props$promptTemplate === void 0 ? void 0 : _props$promptTemplate.id
          }
        };
      }), computed(function () {
        var _props$promptTemplate2;
        return {
          enabled: !!(props !== null && props !== void 0 && (_props$promptTemplate2 = props.promptTemplate) !== null && _props$promptTemplate2 !== void 0 && _props$promptTemplate2.id)
        };
      })),
      result = _useListPromptTemplat.result,
      refetch = _useListPromptTemplat.refetch;
    var templateVersions = computed(function () {
      var _result$value;
      return (result === null || result === void 0 ? void 0 : (_result$value = result.value) === null || _result$value === void 0 ? void 0 : _result$value.listPromptTemplateVersion) || [];
    });
    var _useUpsertPromptTempl = useUpsertPromptTemplateVersionMutation(),
      upsertPromptTemplateVersion = _useUpsertPromptTempl.mutate;
    var _useUpsertPromptTempl2 = useUpsertPromptTemplateMutation(),
      upsertPromptTemplate = _useUpsertPromptTempl2.mutate;
    var _useDeletePromptTempl = useDeletePromptTemplateVersionMutation(),
      deletePromptTemplateVersion = _useDeletePromptTempl.mutate;

    // Delete dialog state
    var deleteDialog = ref({
      show: false,
      versionId: null,
      version: null
    });
    var createPromptTemplate = function createPromptTemplate() {
      if (!props.questionId || !props.ixId) {
        console.error('Cannot create prompt template: questionId and ixId are required');
        return;
      }
      upsertPromptTemplate({
        input: {
          ixId: props.ixId,
          questionId: props.questionId,
          isActive: false
        }
      }).then(function () {
        emit('prompt-template-created');
        promptTemplateExpanded.value = true;
      }).catch(function (error) {
        console.error('Failed to create prompt template:', error);
      });
    };
    var triggerAddTemplateVersion = function triggerAddTemplateVersion() {
      var _props$promptTemplate3;
      upsertPromptTemplateVersion({
        input: {
          promptTemplateId: props === null || props === void 0 ? void 0 : (_props$promptTemplate3 = props.promptTemplate) === null || _props$promptTemplate3 === void 0 ? void 0 : _props$promptTemplate3.id,
          userTemplate: '',
          model: "GPT_4O",
          params: {},
          appendCompanyWebsiteScrape: false
        }
      }).then(function () {
        refetch();
      }).catch(function (error) {
        console.error('Failed to create prompt template version:', error);
      });
    };
    var toggleVersionEditing = function toggleVersionEditing(versionId) {
      if (editingVersionId.value === versionId) {
        editingVersionId.value = null; // Cancel editing
        // Clear stored values when stopping editing
        delete originalValues.value[versionId];
      } else {
        // Store original values when starting editing
        var version = templateVersions.value.find(function (v) {
          return v.id === versionId;
        });
        if (version) {
          originalValues.value[versionId] = {
            systemTemplate: version.systemTemplate,
            model: version.model,
            userTemplate: version.userTemplate,
            notes: version.notes,
            params: version.params,
            inputSchema: version.inputSchema,
            outputSchema: version.outputSchema,
            appendCompanyWebsiteScrape: version.appendCompanyWebsiteScrape
          };
        }
        editingVersionId.value = versionId; // Start editing
      }
    };
    var updateTemplateVersion = function updateTemplateVersion(versionId, field, value) {
      var _originalValues$value;
      // Check if value has actually changed
      var originalValue = (_originalValues$value = originalValues.value[versionId]) === null || _originalValues$value === void 0 ? void 0 : _originalValues$value[field];
      if (originalValue === value) {
        console.log('Value unchanged, skipping update', field, value);
        return;
      }
      var input = _defineProperty({
        id: versionId
      }, field, value);
      upsertPromptTemplateVersion({
        input: input
      }).then(function (result) {
        var _result$data;
        if (result !== null && result !== void 0 && (_result$data = result.data) !== null && _result$data !== void 0 && _result$data.upsertPromptTemplateVersion) {
          // Update stored original value to new value
          if (originalValues.value[versionId]) {
            originalValues.value[versionId][field] = value;
          }
          console.log('Version updated successfully', result.data.upsertPromptTemplateVersion);
        }
      }).catch(function (error) {
        console.error('Failed to update version:', error);
      });
    };
    var updatePromptTemplate = function updatePromptTemplate(id, field, value) {
      var input = _defineProperty({
        id: id
      }, field, value);
      upsertPromptTemplate({
        input: input
      }).then(function (result) {
        var _result$data2;
        if (result !== null && result !== void 0 && (_result$data2 = result.data) !== null && _result$data2 !== void 0 && _result$data2.upsertPromptTemplate) {
          console.log('Template updated successfully', result.data.upsertPromptTemplate);
        }
      }).catch(function (error) {
        console.error('Failed to update template:', error);
      });
    };
    var setAsActiveVersion = function setAsActiveVersion(versionId) {
      upsertPromptTemplate({
        input: {
          id: props.promptTemplate.id,
          latestVersionId: versionId
        }
      });
    };
    var duplicateVersion = function duplicateVersion(version) {
      var _props$promptTemplate4;
      upsertPromptTemplateVersion({
        input: {
          promptTemplateId: props === null || props === void 0 ? void 0 : (_props$promptTemplate4 = props.promptTemplate) === null || _props$promptTemplate4 === void 0 ? void 0 : _props$promptTemplate4.id,
          systemTemplate: version.systemTemplate,
          model: version.model,
          userTemplate: version.userTemplate,
          notes: version.notes,
          params: version.params,
          inputSchema: version.inputSchema,
          outputSchema: version.outputSchema,
          appendCompanyWebsiteScrape: version.appendCompanyWebsiteScrape
        }
      }).then(function () {
        refetch();
      }).catch(function (error) {
        console.error('Failed to duplicate prompt template version:', error);
      });
    };
    var openDeleteDialog = function openDeleteDialog(versionId, version) {
      deleteDialog.value = {
        show: true,
        versionId: versionId,
        version: version
      };
    };
    var handleDeleteConfirm = function handleDeleteConfirm() {
      if (deleteDialog.value.versionId) {
        deletePromptTemplateVersion({
          id: deleteDialog.value.versionId
        }).then(function () {
          refetch();
          deleteDialog.value.show = false;
        }).catch(function (error) {
          console.error('Failed to delete prompt template version:', error);
        });
      }
    };
    return {
      __sfc: true,
      props: props,
      emit: emit,
      activeTab: activeTab,
      promptTemplateExpanded: promptTemplateExpanded,
      editingVersionId: editingVersionId,
      originalValues: originalValues,
      result: result,
      refetch: refetch,
      templateVersions: templateVersions,
      upsertPromptTemplateVersion: upsertPromptTemplateVersion,
      upsertPromptTemplate: upsertPromptTemplate,
      deletePromptTemplateVersion: deletePromptTemplateVersion,
      deleteDialog: deleteDialog,
      createPromptTemplate: createPromptTemplate,
      triggerAddTemplateVersion: triggerAddTemplateVersion,
      toggleVersionEditing: toggleVersionEditing,
      updateTemplateVersion: updateTemplateVersion,
      updatePromptTemplate: updatePromptTemplate,
      setAsActiveVersion: setAsActiveVersion,
      duplicateVersion: duplicateVersion,
      openDeleteDialog: openDeleteDialog,
      handleDeleteConfirm: handleDeleteConfirm
    };
  }
});